export const ENDLESS_VARIETY = {
  heading: 'Our biggest menu ever',
  firstParagraph: 'No more dinner déjà vu. Explore 175+ unforgettable recipes every week.',
  collections: [
    'Vegetarian',
    'Vegan',
    'Gluten-free',
    'Dairy-free',
    'Healthy choices',
    'Family classics',
    'Quick and easy',
    'Global cuisines',
  ],
}
